import { Checkbox, FormControlLabel } from "@mui/material";
import { red } from "@mui/material/colors";
import { useEffect, useRef, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import ErrorText from "./ErrorText";
import ReCAPTCHA from "react-google-recaptcha";
import * as Yup from "yup";
import styles from "../../Styles/modal.module.css";
import { useFormik } from "formik";
import apiCall from "../../helpers/apifactory";
import DatePicker from "react-date-picker";
import Select from "react-select";

const BecomeAFranchise = () => {
  useEffect(() => {
    let current_page = window.location.href.split("/").at(-1);
    setTimeout(() => {
      document
        .getElementById(`${current_page}`)
        ?.scrollIntoView({ block: "center", behavior: "smooth" });
    }, 100);
  });
  window.addEventListener(
    "scroll",
    function (event) {
      let top = this.scrollY,
        window_width = window.innerWidth,
        header_height = document.querySelector("header").style.height + 100;
      // (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
      top > header_height && window_width > 1024
        ? document.querySelector("a").classList.add("fixed-header-desktop")
        : document.querySelector("a").classList.remove("fixed-header-desktop");
    },
    false
  );
  window.addEventListener(
    "scroll",
    function (event) {
      let top = this.scrollY,
        window_width = window.innerWidth,
        header_height = document.querySelector("header").style.height + 100;
      top > header_height && window_width > 1024
        ? document.querySelector("nav").classList.add("fixed-header-desktop")
        : document
            .querySelector("nav")
            .classList.remove("fixed-header-desktop");
      // (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
    },
    false
  );

  const modalRef = useRef(null);
  const [show, setShow] = useState(false);
  const [cities, setCities] = useState([]);
  const [newcities, setNewCities] = useState([]);
  const [originState, setOriginState] = useState("");
  const [isFCValid, setFromCityIsValid] = useState(true);

  const handleChange = (e) => {
    setOriginState(e.value);
  };
  useEffect(() => {
    if (show) {
      modalRef.current.classList.add(styles.visible);
    } else {
      modalRef.current.classList.remove(styles.visible);
    }
  }, [show]);
  useEffect(() => {
    apiCall
      .getCity()
        .then((res) => {
            var cityarr = res?.data?.responseData.cities.map(
          ({ station_code, station_name }) => ({
            value: station_code,
            label: station_name,
          })
        );
        setCities(res?.data?.responseData?.cities);
        setNewCities(cityarr);
      })
      .catch((error) => {
        console.log("===============", error);
      });
  }, []);
  const formik = useFormik({
    initialValues: {
      name: "",
      cnic: "",
      dob: "",
      city: undefined,
      address: "",
      number: "",
      email: "",
      education: "",
      business: "",
      interest: "",
      nearby: "",
      att: [],
      agree: false,
      recaptcha: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("This is Required"),
      cnic: Yup.string()
        .matches(/^[0-9+]{5}-[0-9+]{7}-[0-9]{1}$/, {
          message: "xxxxx-xxxxxxx-x",
          excludeEmptyString: false,
        })
        .required("This is Required"),
      dob: Yup.string().required("This is Required"),
      city: Yup.object()?.required("This is Required"),
      address: Yup.string().required("This is Required"),
      number: Yup.string()
        .matches(/^((\+92)?(0092)?(92)?(0)?)(3)([0-9]{9})$/gm, {
          message: "Invalid phone number",
          excludeEmptyString: false,
        })
        .required("This is Required"),
      email: Yup.string()
        .email("Invalid email address")
        .required("This is Required"),
      education: Yup.string().required("This is Required"),
      business: Yup.string().required("This is Required"),
      interest: Yup.string().required("This is Required"),
      nearby: Yup.string().required("This is Required"),
      agree: Yup.boolean()
        .required("The terms and conditions must be accepted.")
        .oneOf([true], "The terms and conditions must be accepted."),
      recaptcha: Yup.string().required(),
    }),
    onSubmit: (values) => {
      setFromCityIsValid(originState ? true : false);
      if (originState === "") {
        setFromCityIsValid(originState ? true : false);
        return;
      }
      const body = {
        // "toEmailID": 'asad.lodhi@tcs.com.pk',
        toEmailID: "customerservices@tcs.com.pk",
        emailSubject: "Become a TCS Business Partner",
        emailText: `
                    name : ${values?.name},
                    cnic : ${values?.cnic},
                    dob : ${values?.dob},
                     city : ${values?.city},
                    address : ${values?.address},
                    number : ${values?.number},
                    email : ${values?.email},
                    education : ${values?.education},
                    business : ${values?.business},
                    interest : ${values?.interest},
                    nearby : ${values?.nearby},
              `,
        cc: values?.email,
        bcc: values?.email,
        attachments: [],
        replyTo: values?.custEmail,
      };
      apiCall
        .sendEmail(body, {})
        .then((res) => {
          setShow(true);
          formik.setValues(formik?.initialValues);
          formik.setTouched({}, false);
        })
        .catch((error) => {
          console.log("===============", error);
        });
    },
  });
  return (
    <>
      <div className="bg-[#efefef] flex flex-col lg:justify-center justify-center items-center h-[150px]">
        <h1 className="sm:text-[40px] text-[30px] font-bold">
          Become a TCS Business Partner
        </h1>
      </div>

      <div className="my-[3rem]">
        <div className="flex flex-col justify-center mt-[1rem] mb-[1rem] ">
          <div className="flex flex-col gap-3 p-8 shadow-card text-sm md:w-[45rem] sm:w-[40rem] w-[auto] sm:mx-[auto] mx-[1rem] rounded-md transition-all duration-500">
            <h2 className="font-bold text-[1.1rem] ">Personal Information</h2>
            <div className="flex gap-4 mt-4">
              <div className="flex-1 flex flex-col gap-4">
                <div className="sm:flex grid gap-4">
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="text"
                        id="name"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.name}
                        name="name"
                      />
                      <label
                        htmlFor="name"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Name <span className="text-[#F21E26]">*</span>
                      </label>
                    </div>
                    <ErrorText
                      text={formik?.touched?.name && formik?.errors?.name}
                    />
                  </div>

                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="text"
                        id="cnic"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.cnic}
                        name="cnic"
                      />
                      <label
                        htmlFor="cnic"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        CNIC <span className="text-[#F21E26]">*</span>
                      </label>
                    </div>
                    <ErrorText
                      text={formik?.touched?.cnic && formik?.errors?.cnic}
                    />
                  </div>
                </div>
                <div className="sm:flex grid gap-4">
                  <div className="MuiFormControl-root MuiTextField-root flex-1 ">
                    <div className="relative z-20">
                      <DatePicker
                        className="calendar block px-2.5 h-[2.4rem] w-full text-sm text-light bg-transparent rounded border border-gray-500 focus:border-red hover:border-black"
                        onChange={(e) => formik?.setFieldValue("dob", e)}
                        onBlur={formik.handleBlur}
                        value={formik.values.dob}
                        name="dob"
                        id="dob"
                      />

                      <label
                        htmlFor="dob"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2  origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Date of Birth <span className="text-[#F21E26]">*</span>
                      </label>
                    </div>
                    <ErrorText
                      text={formik?.touched?.dob && formik?.errors?.dob}
                    />
                  </div>
                  <div
                    className="MuiFormControl-root flex-1"
                    inputprops="[object Object]"
                    inputlabelprops="[object Object]"
                  >
                    <div className="relative">
                      <Select
                        className="select1"
                        placeholder="Origin (city)"
                        name="city"
                        id="city"
                        value={formik?.values?.city}
                        options={newcities}
                        onChange={(e) => {
                          formik?.setFieldValue("city", e);
                        }}
                        onBlur={(e) => {
                          formik?.setFieldTouched("city", true);
                        }}
                      />
                      <label
                        htmlFor="city"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        City <span className="text-[#F21E26]">*</span>
                      </label>
                      {/* <input
                                            list="data"
                                            className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-black focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                                            name="city"
                                            placeholder="City"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                        
                         
                         
                         
                        
                        value={formik.values.city}
                      /> */}
                      {/* <datalist className="datalist w-[300px] bg-[white]" id="data">
                        <select
                          onChange={(e) => {
                            let result = cities.find(x => x.station_name===e.target.value).station_code;
                            // console.log(newcities, "cities");
                            // setOriginState(result);
                           
                           
                          }}
                        >
                        {cities?.map((data, index) => (
                            <option key={index} value={data?.["station_name"]}>
                              {data?.["station_name"]}
                            </option>
                          ))}
                        </select>
                      </datalist> */}

                      {/* <Select
                        className="select1"
                        placeholder="city"
                        name="from_City"
                        value={newcities.find(
                          (obj) => obj.value === originState
                        )}
                        options={newcities}
                        onChange={handleChange}
                      />
                      <ErrorText text={!isFCValid && <p>This is Required</p>} /> */}
                    </div>

                    {/* <ErrorText text={formik?.touched?.city && formik?.errors?.city} /> */}
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="text"
                        id="address"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.address}
                        name="address"
                      />
                      <label
                        htmlFor="address"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Residential Address{" "}
                        <span className="text-[#F21E26]">*</span>
                      </label>
                    </div>
                    <ErrorText
                      text={formik?.touched?.address && formik?.errors?.address}
                    />
                  </div>
                </div>

                <div className="sm:flex grid gap-4">
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="number"
                        id="number"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.number}
                        name="number"
                      />
                      <label
                        htmlFor="number"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Phone Number<span className="text-[#F21E26]">*</span>
                      </label>
                    </div>
                    <ErrorText
                      text={formik?.touched?.number && formik?.errors?.number}
                    />
                  </div>
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="email"
                        id="email"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.email}
                        name="email"
                      />
                      <label
                        htmlFor="email"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Email Address <span className="text-[#F21E26]">*</span>
                      </label>
                    </div>
                    <ErrorText
                      text={formik?.touched?.email && formik?.errors?.email}
                    />
                  </div>
                </div>

                <div className="sm:flex grid gap-4">
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="text"
                        id="education"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.education}
                        name="education"
                      />
                      <label
                        htmlFor="education"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Education <span className="text-[#F21E26]">*</span>
                      </label>
                    </div>
                    <ErrorText
                      text={
                        formik?.touched?.education && formik?.errors?.education
                      }
                    />
                  </div>
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="text"
                        id="business"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.business}
                        name="business"
                      />
                      <label
                        htmlFor="business"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Current Business/Occupation{" "}
                        <span className="text-[#F21E26]">*</span>
                      </label>
                    </div>
                    <ErrorText
                      text={
                        formik?.touched?.business && formik?.errors?.business
                      }
                    />
                  </div>
                </div>

                <div className="sm:flex grid gap-4">
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="text"
                        id="interest"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.interest}
                        name="interest"
                      />
                      <label
                        htmlFor="interest"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Preferable Area for the Franchise
                        <span className="text-[#F21E26]">*</span>
                      </label>
                    </div>
                    <ErrorText
                      text={
                        formik?.touched?.interest && formik?.errors?.interest
                      }
                    />
                  </div>
                  <div className="MuiFormControl-root MuiTextField-root flex-1">
                    <div className="relative">
                      <input
                        type="text"
                        id="nearby"
                        className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                        placeholder=" "
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.nearby}
                        name="nearby"
                      />
                      <label
                        htmlFor="nearby"
                        className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                      >
                        Nearby Competitor/TCS Centre{" "}
                        <span className="text-[#F21E26]">*</span>
                      </label>
                    </div>
                    <ErrorText
                      text={formik?.touched?.nearby && formik?.errors?.nearby}
                    />
                  </div>
                </div>
                <div>
                  <div className="flex items-center">
                    <FormControlLabel
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      checked={formik.values.agree}
                      name="agree"
                      control={
                        <Checkbox
                          sx={{ "&.Mui-checked": { color: red[600] } }}
                        />
                      }
                      label={
                        <p className="text-[13.5px]">
                          I acknowledge that the details I have provided are
                          accurate, and that I have filled in this form myself.
                        </p>
                      }
                    />
                  </div>
                  <ErrorText
                    text={formik?.touched?.agree && formik?.errors?.agree}
                  />

                  <p className="text-[#9E9E9E]"></p>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col justify-center  mt-[1rem] ">
            <div className="flex gap-4 md:w-[45rem] sm:w-[40rem] w-[auto] mx-[1rem] sm:mx-auto">
              <div className="g-recaptcha">
                <ReCAPTCHA
                  sitekey={process.env.REACT_APP_CAPTCH}
                  onChange={(value) => formik.setFieldValue("recaptcha", value)}
                />
              </div>
            </div>
          </div>
          <button
            onClick={formik?.handleSubmit}
            type="submit"
            className="text-white bg-[#D40511] border border-[#F21E26] md:w-[45rem] sm:w-[40rem] sm:mx-[auto] mx-[1rem] rounded-md mt-[1rem] p-1 h-[2.5rem] text-sm hover:bg-[#F21E26] hover:text-white transition-all duration-500"
          >
            Submit
          </button>
        </div>
        <div
          ref={modalRef}
          // style={backdropStyle}
          className={`${styles.modal__wrap}`}
          onClick={() => setShow(false)}
        >
          <div
            className={`flex flex-col justify-center items-center ${styles.modal}`}
          >
            <div className="bg-white w-full h-[106%] relative z-[1000] rounded-3xl">
              <div className="flex justify-center items-center">
                <img
                  src="/popup-circle.png"
                  alt=""
                  className="mx-auto w-[12.5rem]"
                />
                <img
                  src="/popup-icon.png"
                  alt=""
                  className="absolute top-[-3.5rem] mx-auto w-[7rem]"
                />
              </div>
              <div className="absolute right-[1rem] top-[1rem] ">
                <CloseIcon fontSize="large" style={{ color: "#f21e26" }} />
              </div>
              <div className="flex flex-col text-center justify-center item-center mt-[6rem]">
                <h2 className="font-bold text-xl">Thank you for submitting.</h2>
                <p>We’ll contact you soon.</p>
              </div>
            </div>
            <div className="mx-auto bg-[#ed1d25] w-[80%] h-[2rem] rounded-full mt-[-1.2rem]"></div>
          </div>
        </div>
      </div>
    </>
  );
};
export default BecomeAFranchise;
